import { ReactElement, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DropdownSelect, useDropdownControl } from 'common/components/dropdownSelect';
import { ReactComponent as ArrowDownIcon } from 'images/icons/arrowdown.svg';

import useStatusList from '../hooks/useStatusList';
import useTexts from '../hooks/useTexts';

import { MergeStatusValue, MergeStatusWrapper, StyledAsterisk, StyledFieldLabel } from '../style';
import { selectMergeStatus, setMergeStatus } from '../slice';

const MergeStatusSelect = (): ReactElement => {
  const dispatch = useDispatch();
  const { primarySrStatus, selectText } = useTexts();
  const mergeStatus = useSelector(selectMergeStatus);

  const { anchor, handleOpen, handleClose } = useDropdownControl();

  const { statusList } = useStatusList();

  const handleMergeStatusChange = useCallback(
    (selected) => {
      dispatch(setMergeStatus(selected));
      handleClose();
    },
    [handleClose, dispatch],
  );

  const handleClearValue = () => setMergeStatus([]);

  return (
    <MergeStatusWrapper>
      <StyledFieldLabel>
        {primarySrStatus} <StyledAsterisk />
      </StyledFieldLabel>
      {/* @ts-ignore */}
      <MergeStatusValue onClick={handleOpen} isEmpty={!mergeStatus} data-testId="merge-status-value-dropdown">
        <text>{mergeStatus?.valueCaption || selectText}</text>
        <ArrowDownIcon />
      </MergeStatusValue>
      <DropdownSelect
        //  @ts-ignore
        fieldName="mergeStatus"
        options={statusList}
        handleChange={handleMergeStatusChange}
        handleClose={handleClose}
        selection={[mergeStatus]}
        anchor={anchor}
        handleClearValue={handleClearValue}
      />
    </MergeStatusWrapper>
  );
};

export default MergeStatusSelect;
